// Note: make sure each key have their relevant Editor instances attached in EditorView.js
export const EDITOR_KEYS = {
  taskEditor: "edit-task-editor",
  resourceEditor: "edit-resource-editor",
  resourceEditorV2: "edit-resource-editor-v2",
  clientEditorV2: "edit-client-editor-v2",
  agendaEditor: "edit-agenda-editor",
  messageEditor: "edit-message-editor",
  settingsEditor: "edit-settings-editor",
  settingPersonalEditor: "edit-setting-personal-editor",
  importEditor: "import-editor",
  agendaMessageEditor: "agenda-message-editor",
  aboutModal: "about-modal",
  viewOrganizerEditor: "view-organizer-editor",
  shareSchedulerPopup: "share-scheduler-popup",
  richTextEditor: "swivu-rich-text-editor",
  userEditor: "swivu-user-editor",
  contactEditor: "swivu-contact-editor",
  entityFinder: "swivu-entity-finder",
  timelineConfiguratorEditor: "swivu-timeline-configurator-editor",
  entityTagEditor: "swivu-entity-tag-editor",
  boardAlertEditor: "swivu-board-alert-editor",
  budgetEditor: "swivu-budget-editor",
  viewInspectorEditor: "swivu-view-inspector-editor",
  asyncTaskMessageEditor: "swivu-async-task-message-editor",
  outcomeIncentiveEditor: "swivu-outcome-incentive-editor",
  spotIncentiveEditor: "swivu-spot-incentive-editor",
  pointsLeaderboardPopup: "swivu-points-leaderboard-popup",
  awardTagEditor: "swivu-award-tag-editor",
  taskFilesEditor: "swivu-task-files-editor",
  taskFinderEditor: "swivu-task-finder-editor",
  swivuAssistEditor: "swivu-assist-editor",
  checklistEditor: "swivu-checklist-editor",
  duplicateBoardEditor: "swivu-duplicate-board-editor",
  myMediaEditor: "swivu-my-media-editor",
  noteEditor: "swivu-note-editor",
  marketingAssetEditor: "swivu-marketing-asset-editor",
  fileSelectorEditor: "swivu-file-selector-editor",
};

export const EDITOR_DATA_TAG = {
  key: "dialogRefId",
  value: "data-dialog-ref-id"
};
